var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderConfirmation text-center"},[(!_vm.loaded)?_c('div',[_c('loading-indicator',{attrs:{"message":"Getting Order Confirmation."}})],1):_c('div',[_c('shipping-label',{attrs:{"confirmationContent":_vm.confirmationContent,"label":_vm.confirmation}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }